import type { Theme } from '@mui/material/styles';

/**
 * Shared Recharts <Tooltip> styling derived from the MUI theme, so chart
 * tooltips are readable in both light and dark mode (dark surface + light text).
 * Recharts defaults to dark text, which is invisible on the dark paper surface —
 * always spread these props onto a chart Tooltip.
 *
 * Usage: <Tooltip {...chartTooltipProps(theme)} formatter={...} />
 */
export function chartTooltipProps(theme: Theme) {
  return {
    contentStyle: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 8,
      color: theme.palette.text.primary,
    },
    itemStyle: { color: theme.palette.text.primary },
    labelStyle: { color: theme.palette.text.primary },
  };
}
